export const PROFILE = {
    NAME: "profile-name",
    EMAIL: "profile-email",
    PASSWORD: "profile-password",
    CONFIRM_PASSWORD: "profile-confirm-password",
    CURRENT_PASSWORD: "profile-current-password",
    SUBMIT: "profile-submit",
    PASSWORD_STRENGTH: "profile-password-strength",
    PROFILE_LOCALE: "profile-locale",
    PROFILE_DROPDOWN: "profile-dropdown",
    YOUR_PROFILE: "your-profile",
    HELP: "help",
    ENTER_BRAND: "enter-brand",
    SETTINGS: "settings",
    PROFILE_LOGOUT: "profile-logout",
    OPTIN_NEW_PRODUCT_DETAILS: "optin-product-details",
    OPTIN_NEW_CONTACTS_PAGES: "optin-contacts-pages",
    BACK_TO_APPLICATION: "backto-application",
    TEMP_PASSWORD_TEXT: "temp-password-msg",
    GRID_VIEW_TYPES: {
        PANEL: "panel",
        TILE: "tile",
        LARGE_TILE: "largeTile",
        CARD: "card",
        LIST: "list",
    },
};
